import React from 'react'
import "./Message.css";

const Message = (props) => {
  return (
   
      <div id="message">{props.msg}</div>
  )
}

export default Message
